import { DamageType } from "../damageType";
import { PhysicalThingWithHp, STD_BASE_HP } from "../physicalThingWithHp";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export abstract class MobCorpse extends PhysicalThingWithHp {
	constructor(xy: XY) {
		super(xy, false);
		this.hp = STD_BASE_HP;
		this.maxHp = STD_BASE_HP;
		this.damageMultipliers.set(DamageType.BUBBLE, 0);
		this.damageMultipliers.set(DamageType.TOXIC_GAS, 0);
		this.damageMultipliers.set(DamageType.ELECTRIC, 0);
	}

	getZOrder(): number {
		return ZOrder.CORPSE;
	}

	isVisible(): boolean {
		return true;
	}

	isHideUnderneath(): boolean {
		return false;
	}

	/**
	 * If this corpse can be resurrected by an EngineerRobot, return the mob factory key
	 * to spawn at the corpse's cell. Default null means non-repairable.
	 */
	getRepairableMobKey(): string | null {
		return null;
	}
}
